import { render } from "./message-branch.vue?vue&type=template&id=5fd33cca&ts=true"
import script from "./message-branch.vue?vue&type=script&lang=ts"
export * from "./message-branch.vue?vue&type=script&lang=ts"

import "./message-branch.vue?vue&type=style&index=0&id=5fd33cca&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__